module.exports = __webpack_public_path__ + "static/media/contacts.c9fe94af.png";